/** Simple path icons (no text) for graphic widgets — self-hosted SVG paths in 24x24 viewBox. */
export const GRAPHIC_ICON_PATHS = {
    dot: "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
    star: "M12 2l2.4 7.4H22l-6 4.6 2.3 7L12 17.8 5.7 21l2.3-7-6-4.6h7.6z",
    check: "M5 12.5 9.5 17 19 7",
    arrow: "M5 12h14M13 6l6 6-6 6",
    circle: "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0",
    diamond: "M12 3l8 9-8 9-8-9z",
    bolt: "M13 2 5 14h6l-1 8 8-12h-6z",
    heart: "M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10z",
};
export function graphicIconPath(icon) {
    const id = icon;
    return GRAPHIC_ICON_PATHS[id] ?? GRAPHIC_ICON_PATHS.dot;
}
